module.exports = __webpack_public_path__ + "static/media/check-box.406450f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/check-box.svg
// module id = 191
// module chunks = 0